/**
 * Pause is a render-time toggle, not a sim concept. The loop checks
 * `isPaused()` each frame; when true, it renders but does not step.
 *
 * Phase transition note: pausing does not change `state.phase`. The HUD
 * detects a paused render and overlays its own "PAUSED" banner via
 * pause-aware code in the renderer (see render entry point).
 */

export type PauseController = {
  isPaused(): boolean;
  toggle(): void;
  set(paused: boolean): void;
  dispose(): void;
};

export function attachPause(target: Window | HTMLElement = window, key = 'KeyP'): PauseController {
  let paused = false;
  function onKey(ev: KeyboardEvent): void {
    if (ev.code === key && !ev.repeat) {
      paused = !paused;
      ev.preventDefault();
    }
  }
  target.addEventListener('keydown', onKey as EventListener);
  return {
    isPaused: () => paused,
    toggle: () => { paused = !paused; },
    set: (p) => { paused = p; },
    dispose: () => target.removeEventListener('keydown', onKey as EventListener),
  };
}
